import React, { useEffect, useState } from 'react';
import {
    Box,
    Card,
    CardHeader,
    Container,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Button
} from '@mui/material';
import axios from 'axios';
import { saveAs } from 'file-saver';

function StockReport() {
    const [stockData, setStockData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    useEffect(() => {
        fetchStockData();
    }, []);

    async function fetchStockData() {
        try {
            const res = await axios.get('https://serveralgama.mylksystems.com/sales/getStock');
            if (res.data.length > 0) {
                setStockData(res.data);
                setFilteredData(res.data);
            }
        } catch (error) {
            console.error("Error fetching stock data", error);
        }
    }

    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
        const filtered = stockData.filter(stock =>
            stock.ItemName.toLowerCase().includes(value)
        );
        setFilteredData(filtered);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDownloadCSV = () => {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0].replace(/-/g, '.'); // Format: YYYY.MM.DD
        const fileName = `${formattedDate}_stock_report.csv`;
    
        const csvHeaders = 'StockId,ItemId,ItemName,LastStockUpdated,AvailableStock\n';
        const csvRows = filteredData.map(stock =>
            `${stock.StockId},${stock.ItemId},"${stock.ItemName}",${stock["Last Stock Updated"]},${stock["available Stock"]}`
        ).join('\n');
    
        const csvData = new Blob([csvHeaders + csvRows], { type: 'text/csv' });
        saveAs(csvData, fileName);
    };
    

    return (
        <Container maxWidth={false}>
            <Card sx={{ padding: '15px' }}>
                <CardHeader title="Stock Report" />
                <Divider />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 2 }}>
                    <TextField
                        label="Search by Item Name"
                        variant="outlined"
                        size="small"
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                    <Button variant="contained" color="primary" onClick={handleDownloadCSV}>
                        Download CSV
                    </Button>
                </Box>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Stock ID</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Item ID</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Item Name</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Last Stock Updated</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Available Stock</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{row.StockId}</TableCell>
                                    <TableCell>{row.ItemId}</TableCell>
                                    <TableCell>{row.ItemName}</TableCell>
                                    <TableCell>{row["Last Stock Updated"]}</TableCell>
                                    <TableCell>{row["available Stock"]}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Card>
        </Container>
    );
}

export default StockReport;
